/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const InstagramWelcomerIcon = ({
  className,
  style,
  color = '#312D4A',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.58551 0.75C2.26214 0.75 2 1.03391 2 1.38412V15.8784C2 16.2286 2.26214 16.5125 2.58551 16.5125H13.4593C13.7827 16.5125 14.0448 16.2286 14.0448 15.8784V1.38412C14.0448 1.03391 13.7827 0.75 13.4593 0.75H2.58551ZM2.58551 15.8784V1.38412H13.4593V15.8784H2.58551ZM3.84018 12.2548C3.6092 12.2548 3.42195 12.4576 3.42195 12.7077C3.42195 12.9579 3.6092 13.1607 3.84018 13.1607H12.2046C12.4356 13.1607 12.6229 12.9579 12.6229 12.7077C12.6229 12.4576 12.4356 12.2548 12.2046 12.2548H3.84018ZM3.42195 14.5195C3.42195 14.2693 3.6092 14.0665 3.84018 14.0665H12.2046C12.4356 14.0665 12.6229 14.2693 12.6229 14.5195C12.6229 14.7696 12.4356 14.9724 12.2046 14.9724H3.84018C3.6092 14.9724 3.42195 14.7696 3.42195 14.5195ZM7.60484 2.75196C7.73575 2.7529 7.86765 2.75386 8.0001 2.75386H7.99829C8.15583 2.75386 8.30818 2.75283 8.45556 2.75183C9.73291 2.74322 10.6379 2.73711 11.3256 3.42429C12.0107 4.1084 12.0058 4.99785 11.9986 6.31598C11.9978 6.45557 11.997 6.59997 11.997 6.74944C11.997 6.88767 11.9975 7.02079 11.998 7.14911C12.0016 8.11229 12.0042 8.80528 11.7872 9.36627C11.2384 10.7732 9.84363 10.7605 8.41178 10.7475C8.27435 10.7463 8.13659 10.745 7.9992 10.745C7.86759 10.745 7.73637 10.746 7.60601 10.7469C6.12552 10.7577 4.75655 10.7677 4.21162 9.36627C3.99503 8.80911 3.99791 7.9806 4.00104 7.07897C4.00142 6.97008 4.00181 6.86012 4.00181 6.74944C4.00181 6.61319 4.00132 6.48172 4.00086 6.35478C3.99732 5.39123 3.99473 4.6883 4.21162 4.13216C4.75785 2.73142 6.11645 2.74122 7.60484 2.75196ZM8.28475 3.46962C8.08318 3.47152 7.8691 3.47353 7.64183 3.47389V3.47299C4.976 3.47569 4.72331 3.52619 4.72331 6.74763C4.72331 9.93211 4.81491 10.0232 8.00055 10.0232C8.1613 10.0232 8.3193 10.0249 8.47375 10.0266C9.99793 10.0433 11.1769 10.0563 11.2543 8.36264C11.4784 3.43956 11.1143 3.44299 8.28475 3.46962ZM9.65474 4.61639C9.65474 4.35173 9.86952 4.13711 10.1344 4.13711C10.3993 4.13711 10.614 4.35173 10.614 4.61639C10.614 4.88104 10.3993 5.09566 10.1344 5.09566C9.86952 5.09566 9.65474 4.88104 9.65474 4.61639ZM5.94703 6.74944C5.94703 5.61641 6.86617 4.69754 8.0001 4.69754C9.13402 4.69754 10.0527 5.61641 10.0527 6.74944C10.0527 7.88247 9.13402 8.80088 8.0001 8.80088C6.86617 8.80088 5.94703 7.88247 5.94703 6.74944ZM8.0001 5.41758C9.76213 5.41758 9.76438 8.0813 8.0001 8.0813C6.23852 8.0813 6.23581 5.41758 8.0001 5.41758Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
